class DbtfyTravel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.sliderEl = this.querySelector(".splide");
    if (!this.sliderEl) return;

    this.splide = new Splide(this.sliderEl, {
      type: 'slide',
      perMove: 1,
      perPage: 3,
      padding: { left: "5%", right: "5%" },
      gap: "30px",
      drag: "free",
      snap: true,
      arrows: true,
      pagination: false,
      trimSpace: true,
      breakpoints: {
        640: {
          perPage: 1,
          fixedWidth: "250px",
          gap: "20px",
          padding: { left: "3%", right: "3%" },
        },
      },
    }).mount();
  }

  disconnectedCallback() {
    if (this.splide) {
      this.splide.destroy();
    }
  }
}

if (!customElements.get("dbtfy-travel")) {
  customElements.define("dbtfy-travel", DbtfyTravel);
}